module.exports = __webpack_public_path__ + "dash_20_app_assets/img/avatar-s-22.4ec94f65.jpg";